// import React, { useCallback } from "react";
// import OstatkiDisplay from "../../../OstatkiDisplay/OstatkiDisplay";
// import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
// import { DeanteData } from "../../../../Universal/API/Context-API/AppProvider";
// import { normalizeText } from "../helpers";
// import { ColorOption, ColorSwatch, SizeOption, SpecItem, TechnicalFieldConfig } from "../types";

// const getColorBadge = (
//   colorBadges: ReturnType<typeof useAppContext>["color_badges"],
//   key: string
// ): ColorSwatch | null => colorBadges?.[key] ?? null;

// const parseColorValues = (value: unknown) =>
//   String(value ?? "")
//     .split(/[,;|/]+/)
//     .map((item) => item.trim())
//     .filter(Boolean);

// const buildVariantColorLabel = (unit: DeanteData) => {
//   const directLabel =
//     normalizeText(unit.color1) ||
//     normalizeText(unit.color2) ||
//     normalizeText(unit.color3);

//   if (directLabel) return directLabel;

//   const palValue = parseColorValues(unit.pal)[0];
//   return normalizeText(palValue) || normalizeText(unit.art) || String(unit.id);
// };

// const buildVariantSizeLabel = (unit: DeanteData) => {
//   const fullSize = normalizeText(unit.full_size);
//   const rawParts = (fullSize
//     ? fullSize
//     : [unit.width, unit.height, unit.thick].filter(Boolean).join("x"))
//     .split("x")
//     .map((part) => String(part).trim())
//     .filter(Boolean);

//   if (rawParts.length >= 2) {
//     const leftRaw = parseFloat(rawParts[0].replace(",", "."));
//     const rightRaw = parseFloat(rawParts[rawParts.length - 1].replace(",", "."));

//     const left = Number.isFinite(leftRaw) ? Math.round(leftRaw / 10) : rawParts[0];
//     const right = Number.isFinite(rightRaw) ? Math.round(rightRaw) : rawParts[rawParts.length - 1];

//     return `${left}x${right}`;
//   }

//   return fullSize || normalizeText(unit.art) || String(unit.id);
// };

// const buildVariantFamily = (
//   unit: DeanteData,
//   allUnitData?: Record<string | number, DeanteData> | null
// ) => {
//   const relatedIds = [unit.id, ...(Array.isArray(unit.krat) ? unit.krat : [])]
//     .map((value) => String(value ?? "").trim())
//     .filter(Boolean);

//   const uniqueRelatedIds = relatedIds.filter(
//     (value, index, array) => array.indexOf(value) === index
//   );

//   if (!allUnitData) return [];

//   return uniqueRelatedIds
//     .map((variantId) => allUnitData[variantId] ?? allUnitData[Number(variantId)])
//     .filter(Boolean)
//     .filter(
//       (variantUnit, index, array) =>
//         array.findIndex((candidate) => String(candidate.id) === String(variantUnit.id)) === index
//     );
// };

// const TECHNICAL_FIELDS_CONFIG: TechnicalFieldConfig[] = [
//   {
//     key: "col",
//     label: "Коллекция",
//     getValue: (unit) => unit.col,
//     action: "collection",
//     actionValue: (unit) => unit.col,
//   },
//   {
//     key: "art",
//     label: "Код продукта",
//     getValue: (unit) => unit.art,
//     action: "copy",
//     actionValue: (unit) => unit.art,
//   },
//   {
//     key: "color1",
//     label: "Отделка",
//     getValue: (unit) => unit.color1,
//   },
//   {
//     key: "poverh",
//     label: "Поверхность",
//     getValue: (unit) => unit.poverh,
//   },
//   {
//     key: "material",
//     label: "Материал",
//     getValue: (unit) => unit.material,
//   },
//   {
//     key: "full_size",
//     label: "Размер",
//     getValue: (unit) => unit.full_size,
//     enabled: false,
//   },
//   {
//     key: "width",
//     label: "Ширина",
//     getValue: (unit) => {
//       const text = normalizeText(unit.width);
//       if (!text) return null;
//       return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
//     },
//     enabled: false,
//   },
//   {
//     key: "height",
//     label: "Высота",
//     getValue: (unit) => {
//       const text = normalizeText(unit.height);
//       if (!text) return null;
//       return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
//     },
//     enabled: false,
//   },
//   {
//     key: "thick",
//     label: "Толщина",
//     getValue: (unit) => {
//       const text = normalizeText(unit.thick);
//       if (!text) return null;
//       return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
//     },
//     enabled: false,
//   },
//   {
//     key: "ves",
//     label: "Вес",
//     getValue: (unit) => {
//       const text = normalizeText(unit.ves);
//       if (!text) return null;
//       return /[a-zA-Zа-яА-Я%]/.test(text)
//         ? text
//         : `${text} ${normalizeText(unit.vesED) ?? "кг"}`;
//     },
//     enabled: false,
//   },
// ];

// export const useResolve = () => {
//   const { color_badges } = useAppContext();

//   const resolveSwatchColor = useCallback(
//     (labelColor: string, surface?: string | null) => {
//       const normalized = labelColor.toLowerCase();
//       const normalizedSurface = (surface ?? "").toLowerCase();

//     //   console.log('color_badges', color_badges)

//     console.log('normalized', normalized)
//       if (
//         normalized.includes("white") ||
//         normalized.includes("bianco") ||
//         normalized.includes("blanco") ||
//         normalized.includes("bia") ||
//         normalized.includes("бел")
//       ) {
//         return getColorBadge(color_badges, "white") ?? "#F8F8F6";
//       }

//       if (normalized.includes("bras") || normalized.includes("мед")) {
//         return getColorBadge(color_badges, "brass") ?? "#B5A642";
//       }

//       if (
//         normalized.includes("black") ||
//         normalized.includes("nero") ||
//         normalized.includes("czarn") ||
//         normalized.includes("graphite") ||
//         normalized.includes("grafit") ||
//         normalized.includes("anthracite") ||
//         normalized.includes("черн")
//       ) {
//         return getColorBadge(color_badges, "black") ?? "#1B1B1D";
//       }

//       if (
//         normalized.includes("gold") ||
//         normalized.includes("zlot") ||
//         normalized.includes("золот")
//       ) {
//         if (normalizedSurface.includes("мат") || normalizedSurface.includes("mat")) {
//           return getColorBadge(color_badges, "gold-matt") ?? "#B99247";
//         }

//         return getColorBadge(color_badges, "gold-gloss") ?? "#B99247";
//       }

//       if (
//         normalized.includes("chrome") ||
//         normalized.includes("chrom") ||
//         normalized.includes("chro") || 
//         normalized.includes('хро')
//       ) {
//         return getColorBadge(color_badges, "chrome") ?? "#B7BCC4";
//       }

//       if (
//         normalized.includes("steel") ||
//         normalized.includes("stal") ||
//         normalized.includes("inox")
//       ) {
//         return getColorBadge(color_badges, "steel") ?? "#B7BCC4";
//       }

//        if(normalized.includes('titan')){
//          return getColorBadge(color_badges, "titan") ?? "#8B9098";
//       }

//       if (
//         normalized.includes("gray") ||
//         normalized.includes("grey") ||
//         normalized.includes("szary") ||
//         normalized.includes("сер")
//       ) {
//         return "#8B9098";
//       }

     

//       if (normalized.includes("beige") || normalized.includes("беж")) {
//         return "#C8B79F";
//       }

//       return "#D8D5CF";
//     },
//     [color_badges]
//   );

//   const buildFallbackColorOptions = useCallback(
//     (unit: DeanteData): ColorOption[] => {
//       const palValues = parseColorValues(unit.pal);
//       const fallbackLabels = [unit.color1, unit.color2, unit.color3]
//         .map((value) => normalizeText(value))
//         .filter(Boolean) as string[];

//       const sourceValues = palValues.length > 0 ? palValues : fallbackLabels;

//       return sourceValues
//         .filter((value, index, array) => array.indexOf(value) === index)
//         .map((value, index) => ({
//           key: `color_${index}_${value}`,
//           label: fallbackLabels[index] ?? value,
//           swatch: resolveSwatchColor(value, unit.poverh),
//         }));
//     },
//     [resolveSwatchColor]
//   );

//   const buildColorOptions = useCallback(
//     (
//       unit: DeanteData,
//       allUnitData?: Record<string | number, DeanteData> | null
//     ): ColorOption[] => {
//       const variantFamily = buildVariantFamily(unit, allUnitData);
//       const currentColorLabel = buildVariantColorLabel(unit);
//       const currentSizeLabel = buildVariantSizeLabel(unit);

//       if (variantFamily.length > 1) {
//         const colorBuckets = new Map<string, DeanteData[]>();

//         variantFamily.forEach((variantUnit) => {
//           const colorLabel = buildVariantColorLabel(variantUnit);
//           const bucket = colorBuckets.get(colorLabel) ?? [];
//           bucket.push(variantUnit);
//           colorBuckets.set(colorLabel, bucket);
//         });

//         const uniqueVariantOptions = Array.from(colorBuckets.entries()).map(
//           ([colorLabel, variants]) => {
//             const matchedByCurrentSize =
//               variants.find(
//                 (variantUnit) => buildVariantSizeLabel(variantUnit) === currentSizeLabel
//               ) ?? variants[0];

//             return {
//               key: `variant_color_${colorLabel}`,
//               label: colorLabel,
//               swatch: resolveSwatchColor(colorLabel, matchedByCurrentSize.poverh),
//               unitId: matchedByCurrentSize.id,
//               isActive: colorLabel === currentColorLabel,
//             } satisfies ColorOption;
//           }
//         );

//         if (uniqueVariantOptions.length > 0) {
//           return uniqueVariantOptions;
//         }
//       }

//       return buildFallbackColorOptions(unit);
//     },
//     [buildFallbackColorOptions, resolveSwatchColor]
//   );

//   const buildSizeOptions = useCallback(
//     (
//       unit: DeanteData,
//       allUnitData?: Record<string | number, DeanteData> | null
//     ): SizeOption[] => {
//       const variantFamily = buildVariantFamily(unit, allUnitData);
//       if (variantFamily.length <= 1) return [];

//       const currentColorLabel = buildVariantColorLabel(unit);
//       const currentSizeLabel = buildVariantSizeLabel(unit);
//       const sizeBuckets = new Map<string, DeanteData[]>();

//       variantFamily.forEach((variantUnit) => {
//         const sizeLabel = buildVariantSizeLabel(variantUnit);
//         const bucket = sizeBuckets.get(sizeLabel) ?? [];
//         bucket.push(variantUnit);
//         sizeBuckets.set(sizeLabel, bucket);
//       });

//       const sizeOptions = Array.from(sizeBuckets.entries()).map(([sizeLabel, variants]) => {
//         const matchedByCurrentColor =
//           variants.find((variantUnit) => buildVariantColorLabel(variantUnit) === currentColorLabel) ??
//           variants[0];

//         return {
//           key: `variant_size_${sizeLabel}`,
//           label: sizeLabel,
//           unitId: matchedByCurrentColor.id,
//           isActive: sizeLabel === currentSizeLabel,
//         } satisfies SizeOption;
//       });

//       return sizeOptions.length > 1 ? sizeOptions : [];
//     },
//     []
//   );

//   const buildTechnicalSpecs = useCallback(
//     ({
//       unit,
//       isAvailable,
//       scaleAll,
//     }: {
//       unit: DeanteData;
//       isAvailable: boolean;
//       scaleAll: number;
//     }): SpecItem[] => {
//       const items: SpecItem[] = [];

//       const pushText = ({
//         key,
//         label,
//         value,
//         action,
//         actionValue,
//       }: {
//         key: string;
//         label: string;
//         value: unknown;
//         action?: SpecItem["action"];
//         actionValue?: string;
//       }) => {
//         const text = normalizeText(value);
//         if (!text) return;
//         items.push({
//           key,
//           label,
//           value: text,
//           action,
//           actionValue,
//         });
//       };

//       TECHNICAL_FIELDS_CONFIG.forEach((field) => {
//         if (field.enabled === false) return;

//         pushText({
//           key: field.key,
//           label: field.label,
//           value: field.getValue(unit),
//           action: field.action,
//           actionValue: field.actionValue?.(unit),
//         });
//       });

//       if (isAvailable) {
//         items.push({
//           key: "availability",
//           label: "Наличие",
//           value: <OstatkiDisplay unit={unit} scaleAll={scaleAll} compact={true} />,
//           renderAsNode: true,
//         });
//       }

//       return items;
//     },
//     []
//   );

//   return {
//     buildColorOptions,
//     buildSizeOptions,
//     buildTechnicalSpecs,
//     resolveSwatchColor,
//   };
// };


import React, { useCallback } from "react";
import OstatkiDisplay from "../../../OstatkiDisplay/OstatkiDisplay";
import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
import { DeanteData } from "../../../../Universal/API/Context-API/AppProvider";
import { normalizeText } from "../helpers";
import { ColorOption, ColorSwatch, SizeOption, SpecItem, TechnicalFieldConfig } from "../types";

const getColorBadge = (
  colorBadges: ReturnType<typeof useAppContext>["color_badges"],
  key: string
): ColorSwatch | null => colorBadges?.[key] ?? null;

const parseColorValues = (value: unknown) =>
  String(value ?? "")
    .split(/[,;|/]+/)
    .map((item) => item.trim())
    .filter(Boolean);

const buildVariantColorLabel = (unit: DeanteData) => {
  const directLabel =
    normalizeText(unit.color1) ||
    normalizeText(unit.color2) ||
    normalizeText(unit.color3);

  if (directLabel) return directLabel;

  const palValue = parseColorValues(unit.pal)[0];
  return normalizeText(palValue) || normalizeText(unit.art) || String(unit.id);
};

const buildVariantSizeLabel = (unit: DeanteData) => {
  const fullSize = normalizeText(unit.full_size);
  const rawParts = (fullSize
    ? fullSize
    : [unit.width, unit.height, unit.thick].filter(Boolean).join("x"))
    .split("x")
    .map((part) => String(part).trim())
    .filter(Boolean);

  if (rawParts.length >= 2) {
    const leftRaw = parseFloat(rawParts[0].replace(",", "."));
    const rightRaw = parseFloat(rawParts[rawParts.length - 1].replace(",", "."));

    const left = Number.isFinite(leftRaw) ? Math.round(leftRaw / 10) : rawParts[0];
    const right = Number.isFinite(rightRaw) ? Math.round(rightRaw) : rawParts[rawParts.length - 1];

    return `${left}x${right}`;
  }

  return fullSize || normalizeText(unit.art) || String(unit.id);
};

const buildVariantFamily = (
  unit: DeanteData,
  allUnitData?: Record<string | number, DeanteData> | null
) => {
  const relatedIds = [unit.id, ...(Array.isArray(unit.krat) ? unit.krat : [])]
    .map((value) => String(value ?? "").trim())
    .filter(Boolean);

  const uniqueRelatedIds = relatedIds.filter(
    (value, index, array) => array.indexOf(value) === index
  );

  if (!allUnitData) return [];

  return uniqueRelatedIds
    .map((variantId) => allUnitData[variantId] ?? allUnitData[Number(variantId)])
    .filter(Boolean)
    .filter(
      (variantUnit, index, array) =>
        array.findIndex((candidate) => String(candidate.id) === String(variantUnit.id)) === index
    );
};

const TECHNICAL_FIELDS_CONFIG: TechnicalFieldConfig[] = [
  {
    key: "col",
    label: "Коллекция",
    getValue: (unit) => unit.col,
    action: "collection",
    actionValue: (unit) => unit.col,
  },
  {
    key: "art",
    label: "Код продукта",
    getValue: (unit) => unit.art,
    action: "copy",
    actionValue: (unit) => unit.art,
  },
  {
    key: "color1",
    label: "Отделка",
    getValue: (unit) => unit.color1,
  },
  {
    key: "poverh",
    label: "Поверхность",
    getValue: (unit) => unit.poverh,
  },
  {
    key: "material",
    label: "Материал",
    getValue: (unit) => unit.material,
  },
  {
    key: "full_size",
    label: "Размер",
    getValue: (unit) => unit.full_size,
    enabled: false,
  },
  {
    key: "width",
    label: "Ширина",
    getValue: (unit) => {
      const text = normalizeText(unit.width);
      if (!text) return null;
      return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
    },
    enabled: false,
  },
  {
    key: "height",
    label: "Высота",
    getValue: (unit) => {
      const text = normalizeText(unit.height);
      if (!text) return null;
      return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
    },
    enabled: false,
  },
  {
    key: "thick",
    label: "Толщина",
    getValue: (unit) => {
      const text = normalizeText(unit.thick);
      if (!text) return null;
      return /[a-zA-Zа-яА-Я%]/.test(text) ? text : `${text} мм`;
    },
    enabled: false,
  },
  {
    key: "ves",
    label: "Вес",
    getValue: (unit) => {
      const text = normalizeText(unit.ves);
      if (!text) return null;
      return /[a-zA-Zа-яА-Я%]/.test(text)
        ? text
        : `${text} ${normalizeText(unit.vesED) ?? "кг"}`;
    },
    enabled: false,
  },
];

type ColorBadgeKey =
  | "black"
  | "brass"
  | "bronze-matt"
  | "chrome"
  | "gold-gloss"
  | "gold-matt"
  | "steel"
  | "titan"
  | "white";

type ColorRule = {
  badge: ColorBadgeKey;
  aliases: readonly string[];
  fallback: string;
};

const COLOR_RULES: readonly ColorRule[] = [
  {
    badge: "white",
    aliases: ["white", "bianco", "blanco", "bia", "бел", "snow"],
    fallback: "#F8F8F6",
  },
  {
    badge: "black",
    aliases: [
      "black",
      "nero",
      "czarn",
      "graphite",
      "grafit",
      "anthracite",
      "черн",
      "графит",
      "антрацит",
      "carbon",
    ],
    fallback: "#1B1B1D",
  },
  {
    badge: "brass",
    aliases: ["brass", "латун", "мед", "copper"],
    fallback: "#B5A642",
  },
  {
    badge: "bronze-matt",
    aliases: ["bronze", "bronz", "бронз"],
    fallback: "#8C6239",
  },
  {
    badge: "chrome",
    aliases: ["chrome", "chrom", "chromium", "хром"],
    fallback: "#B7BCC4",
  },
  {
    badge: "steel",
    aliases: ["steel", "stainless", "stal", "inox", "сталь", "стал", "нержав"],
    fallback: "#B7BCC4",
  },
  {
    badge: "titan",
    aliases: ["titan", "titanium", "титан"],
    fallback: "#8B9098",
  },
];

const normalizeColorText = (value?: string | null): string =>
  (value ?? "")
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/[-_/]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const containsAny = (value: string, aliases: readonly string[]): boolean =>
  aliases.some((alias) => value.includes(alias));

export const useResolve = () => {
  const { color_badges } = useAppContext();

  const resolveSwatchColor = useCallback(
    (labelColor: string, surface?: string | null): ColorSwatch => {
      const color = normalizeColorText(labelColor);
      const finish = normalizeColorText(surface);

      // Gold is the only color with separate matt/gloss badge assets.
      if (containsAny(color, ["gold", "zlot", "золот"])) {
        const isMatt = containsAny(`${color} ${finish}`, ["matt", "matte", "мат"]);

        return (
          getColorBadge(color_badges, isMatt ? "gold-matt" : "gold-gloss") ??
          (isMatt ? "#B99247" : "#D4AF37")
        );
      }

      const rule = COLOR_RULES.find(({ aliases }) => containsAny(color, aliases));

      if (rule) {
        return getColorBadge(color_badges, rule.badge) ?? rule.fallback;
      }

      // There are currently no image badges for gray and beige.
      if (containsAny(color, ["gray", "grey", "szary", "сер"])) {
        return "#8B9098";
      }

      if (containsAny(color, ["beige", "беж"])) {
        return "#C8B79F";
      }

      return "#D8D5CF";
    },
    [color_badges]
  );

  const buildFallbackColorOptions = useCallback(
    (unit: DeanteData): ColorOption[] => {
      const palValues = parseColorValues(unit.pal);
      const fallbackLabels = [unit.color1, unit.color2, unit.color3]
        .map((value) => normalizeText(value))
        .filter(Boolean) as string[];

      const sourceValues = palValues.length > 0 ? palValues : fallbackLabels;

      return sourceValues
        .filter(
          (value, index, array) =>
            array.findIndex(
              (candidate) => normalizeColorText(candidate) === normalizeColorText(value)
            ) === index
        )
        .map((value, index) => ({
          key: `color_${index}_${value}`,
          label: fallbackLabels[index] ?? value,
          swatch: resolveSwatchColor(value, unit.poverh),
        }));
    },
    [resolveSwatchColor]
  );

  const buildColorOptions = useCallback(
    (
      unit: DeanteData,
      allUnitData?: Record<string | number, DeanteData> | null
    ): ColorOption[] => {
      const variantFamily = buildVariantFamily(unit, allUnitData);
      const currentColorLabel = buildVariantColorLabel(unit);
      const currentSizeLabel = buildVariantSizeLabel(unit);

      if (variantFamily.length > 1) {
        const colorBuckets = new Map<string, DeanteData[]>();

        variantFamily.forEach((variantUnit) => {
          const colorLabel = buildVariantColorLabel(variantUnit);
          const bucket = colorBuckets.get(colorLabel) ?? [];
          bucket.push(variantUnit);
          colorBuckets.set(colorLabel, bucket);
        });

        const uniqueVariantOptions = Array.from(colorBuckets.entries()).map(
          ([colorLabel, variants]) => {
            const matchedByCurrentSize =
              variants.find(
                (variantUnit) => buildVariantSizeLabel(variantUnit) === currentSizeLabel
              ) ?? variants[0];

            return {
              key: `variant_color_${colorLabel}`,
              label: colorLabel,
              swatch: resolveSwatchColor(colorLabel, matchedByCurrentSize.poverh),
              unitId: matchedByCurrentSize.id,
              isActive: colorLabel === currentColorLabel,
            } satisfies ColorOption;
          }
        );

        if (uniqueVariantOptions.length > 0) {
          return uniqueVariantOptions;
        }
      }

      return buildFallbackColorOptions(unit);
    },
    [buildFallbackColorOptions, resolveSwatchColor]
  );

  const buildSizeOptions = useCallback(
    (
      unit: DeanteData,
      allUnitData?: Record<string | number, DeanteData> | null
    ): SizeOption[] => {
      const variantFamily = buildVariantFamily(unit, allUnitData);
      if (variantFamily.length <= 1) return [];

      const currentColorLabel = buildVariantColorLabel(unit);
      const currentSizeLabel = buildVariantSizeLabel(unit);
      const sizeBuckets = new Map<string, DeanteData[]>();

      variantFamily.forEach((variantUnit) => {
        const sizeLabel = buildVariantSizeLabel(variantUnit);
        const bucket = sizeBuckets.get(sizeLabel) ?? [];
        bucket.push(variantUnit);
        sizeBuckets.set(sizeLabel, bucket);
      });

      const sizeOptions = Array.from(sizeBuckets.entries()).map(([sizeLabel, variants]) => {
        const matchedByCurrentColor =
          variants.find((variantUnit) => buildVariantColorLabel(variantUnit) === currentColorLabel) ??
          variants[0];

        return {
          key: `variant_size_${sizeLabel}`,
          label: sizeLabel,
          unitId: matchedByCurrentColor.id,
          isActive: sizeLabel === currentSizeLabel,
        } satisfies SizeOption;
      });

      return sizeOptions.length > 1 ? sizeOptions : [];
    },
    []
  );

  const buildTechnicalSpecs = useCallback(
    ({
      unit,
      isAvailable,
      scaleAll,
    }: {
      unit: DeanteData;
      isAvailable: boolean;
      scaleAll: number;
    }): SpecItem[] => {
      const items: SpecItem[] = [];

      const pushText = ({
        key,
        label,
        value,
        action,
        actionValue,
      }: {
        key: string;
        label: string;
        value: unknown;
        action?: SpecItem["action"];
        actionValue?: string;
      }) => {
        const text = normalizeText(value);
        if (!text) return;
        items.push({
          key,
          label,
          value: text,
          action,
          actionValue,
        });
      };

      TECHNICAL_FIELDS_CONFIG.forEach((field) => {
        if (field.enabled === false) return;

        pushText({
          key: field.key,
          label: field.label,
          value: field.getValue(unit),
          action: field.action,
          actionValue: field.actionValue?.(unit),
        });
      });

      if (isAvailable) {
        items.push({
          key: "availability",
          label: "Наличие",
          value: <OstatkiDisplay unit={unit} scaleAll={scaleAll} compact={true} />,
          renderAsNode: true,
        });
      }

      return items;
    },
    []
  );

  return {
    buildColorOptions,
    buildSizeOptions,
    buildTechnicalSpecs,
    resolveSwatchColor,
  };
};
